import React from 'react'
import { connect } from 'react-redux'
// import Select from 'react-select'
import { Link } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'

import Forbidden from '../components/Forbidden'
import MustHave from '../containers/MustHave'
import { requireAuthentication } from '../helpers/authentication'
import { downloadModels, downloadMemos } from '../thunks/dtcMemoSearch'
import { selectModel, editDTCField } from '../actions/dtc-memo-search'
import { LOADING_STATE } from '../constants'
import { Input, Button, Form, Row, Col, Select, Table } from 'antd'

const MemoEditLink = ({ memoId, add }) => (
  <Link to={`/dtc-memo/${memoId}${add ? '/add' : ''}`}>
    <Button type="primary" className="uppercase table-btn">
      {add ? 'Add' : 'Edit'}
    </Button>
  </Link>
)

class DtcMemoSearchContainer extends React.Component {
  constructor(props) {
    super(props)
    this.pageSize = 10
  }
  componentDidMount() {
    this.props.doDownloadModels()
  }

  isSearchDisabled() {
    const { selectedModel, dtc } = this.props
    return !selectedModel || dtc.length === 0
  }

  handleSearchByEnterPress(e) {
    if (e.key === 'Enter') {
      this.doSearchOfMemos()
    }
  }

  doSearchOfMemos() {
    const { doDownloadMemos } = this.props
    if (!this.isSearchDisabled()) {
      doDownloadMemos()
    }
  }

  getOccupiedViewportHeight() {
    const yOffset = 264 // 264 is 64px (header height) + 75px (Find DTC memo header) + 84px (DTC memo search cont) + 41px (Table Header)
    const spacer = 20
    return yOffset + spacer
  }

  columns = [
    {
      title: <FormattedMessage id="dtcMemoSearch.dtcName" />,
      dataIndex: 'dtc',
    },
    {
      title: ' ',
      dataIndex: 'active',
      render: (record) => (record.active ? '' : 'Inactive'),
    },
    {
      title: <FormattedMessage id="dtcMemoSearch.module" />,
      dataIndex: 'acronym',
    },
    {
      title: <FormattedMessage id="dtcMemoSearch.description" />,
      dataIndex: 'short_desc',
    },
    {
      title: ' ',
      dataIndex: 'memo',
      render: (_, record) => {
        return <MemoEditLink memoId={record.id} add={record.add} />
      },
    },
  ]

  render() {
    const {
      // data
      models,
      selectedModel,
      dtc,
      memos,
      modelsAreDownloading,
      memosAreDownloading,
      // actions
      doSelectModel,
      doEditDTCField,
      intl,
    } = this.props

    const modelsOpts = models
      ? models.map((m) => ({
          value: JSON.stringify(m),
          label: `${m.model} - ${m.year}`,
        }))
      : null

    return (
      <div>
        <MustHave permission="dtc-memo:get" fallback={<Forbidden />}>
          <Row justify="center">
            <Col xs={24} sm={24} md={22} lg={20} xl={18} xxl={16}>
              <Row className={'mb-2'}>
                <h2 id="memo-authoring">
                  <FormattedMessage id="dtcMemoSearch.pageTitle" />
                </h2>
              </Row>
              <Row style={{ gap: '2%' }}>
                <Col style={{ width: '43%' }}>
                  <Form.Item
                    label={
                      <FormattedMessage id="dtcMemoSearch.selectModelLabel" />
                    }
                    htmlFor="model-select"
                    layout="vertical"
                  >
                    <Select
                      id="model-select"
                      value={selectedModel}
                      options={modelsOpts}
                      onChange={(value, option) => {
                        const selectedoption = {
                          label: option.label,
                          value: JSON.parse(value),
                        }
                        doSelectModel(selectedoption)
                      }}
                      placeholder={intl.formatMessage({
                        id: 'dtcMemoSearch.model',
                      })}
                      disabled={modelsAreDownloading ? true : false}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: '43%' }}>
                  <Form.Item
                    label={
                      <FormattedMessage id="dtcMemoSearch.dtcInputLabel" />
                    }
                    htmlFor="dtc-input"
                    layout="vertical"
                  >
                    <Input
                      id="dtc-input"
                      value={dtc}
                      placeholder={intl.formatMessage({
                        id: 'dtcMemoSearch.example',
                      })}
                      disabled={!selectedModel ? true : false}
                      style={{ width: '100%' }}
                      onChange={(e) => {
                        doEditDTCField(e.target.value)
                      }}
                      onPressEnter={(e) => {
                        this.handleSearchByEnterPress(e)
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: '10%' }}>
                  <Form.Item label={'  '} layout="vertical">
                    <Button
                      id="search-btn"
                      type="primary"
                      onClick={() => this.doSearchOfMemos()}
                      data-cy="dtc-memo-search-submit"
                      disabled={this.isSearchDisabled()}
                    >
                      {this.props.intl.formatMessage({
                        id: 'dtcMemoSearch.search',
                      })}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              {memosAreDownloading === LOADING_STATE.endOk &&
                memos &&
                (memos.length > 0 ? (
                  <Row className="mb-2">
                    <Table
                      style={{ width: '100%' }}
                      columns={this.columns}
                      dataSource={memos}
                      pagination={false}
                      rowKey="id"
                      scroll={{
                        y: `calc(100vh - ${this.getOccupiedViewportHeight()}px)`,
                      }}
                    />
                  </Row>
                ) : (
                  <Row>
                    <FormattedMessage id="dtcMemoSearch.noResults" />
                  </Row>
                ))}
            </Col>
          </Row>
        </MustHave>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  models: state.dtcMemoSearch.models,
  selectedModel: state.dtcMemoSearch.selectedModel,
  dtc: state.dtcMemoSearch.dtc,
  memos: state.dtcMemoSearch.memos,
  modelsAreDownloading: state.dtcMemoSearch.modelsAreDownloading,
  memosAreDownloading: state.dtcMemoSearch.memosAreDownloading,
})

const mapDispatch = (dispatch) => ({
  doDownloadModels: () => dispatch(downloadModels()),
  doSelectModel: (model) => dispatch(selectModel(model)),
  doEditDTCField: (dtc) => dispatch(editDTCField(dtc)),
  doDownloadMemos: () => dispatch(downloadMemos()),
})

const ProtectedDtcMemoSearchContainer = requireAuthentication(
  DtcMemoSearchContainer,
)

export default connect(
  mapStateToProps,
  mapDispatch,
)(injectIntl(ProtectedDtcMemoSearchContainer))
